export const getCountries = () => {
  return ` {
    countryList{
    id,
    name,
    masculine,
    feminine
  }}`
}
